/**
 * Tiny client-safe number formatter for the memberships portal.
 *
 * Returns just the digits — the currency symbol is the
 * <CurrencyIcon /> component's job. See the project Currency
 * Rendering guidance in CLAUDE.md.
 */
export function formatAmount(value: number, locale = 'en'): string {
  const hasFraction = Number.isFinite(value) && value % 1 !== 0;
  return new Intl.NumberFormat(locale, {
    style: 'decimal',
    minimumFractionDigits: hasFraction ? 2 : 0,
    maximumFractionDigits: 2,
  }).format(value);
}

/**
 * Free plans and 100%-discounted memberships read as "Complimentary" to the
 * member instead of a bare 0.
 */
export function isComplimentaryMembership(membership: {
  purchase_price: number;
  payment_status: string;
}) {
  return (
    Number(membership.purchase_price) === 0 ||
    membership.payment_status === 'complimentary'
  );
}
